<div class='loading-animation'
     style='transform:scale(0.2);'>

    <div style='top:80px;left:90px;width:20px;height:40px;background:#780e20;-webkit-transform:rotate(0deg)
    translate(0,-80px);transform:rotate(0deg) translate(0,-80px);border-radius:10px;position:absolute;'>
    </div>

    <div style='top:80px;left:90px;width:20px;height:40px;background:#780e20;-webkit-transform:rotate(30deg)
        translate(0,-80px);transform:rotate(30deg) translate(0,-80px);border-radius:10px;position:absolute;'>
    </div>

    <div style='top:80px;left:90px;width:20px;height:40px;background:#780e20;-webkit-transform:rotate(60deg)
        translate(0,-80px);transform:rotate(60deg) translate(0,-80px);border-radius:10px;position:absolute;'>
    </div>

    <div style='top:80px;left:90px;width:20px;height:40px;background:#780e20;-webkit-transform:rotate(90deg)
        translate(0,-80px);transform:rotate(90deg) translate(0,-80px);border-radius:10px;position:absolute;'>
    </div>

    <div style='top:80px;left:90px;width:20px;height:40px;background:#780e20;-webkit-transform:rotate(120deg)
    translate(0,-80px);transform:rotate(120deg) translate(0,-80px);border-radius:10px;position:absolute;'>
    </div>

    <div style='top:80px;left:90px;width:20px;height:40px;background:#780e20;-webkit-transform:rotate(150deg)
    translate(0,-80px);transform:rotate(150deg) translate(0,-80px);border-radius:10px;position:absolute;'>
    </div>

    <div style='top:80px;left:90px;width:20px;height:40px;background:#780e20;-webkit-transform:rotate(180deg)
    translate(0,-80px);transform:rotate(180deg) translate(0,-80px);border-radius:10px;position:absolute;'>
    </div>

    <div style='top:80px;left:90px;width:20px;height:40px;background:#780e20;-webkit-transform:rotate(210deg)
    translate(0,-80px);transform:rotate(210deg) translate(0,-80px);border-radius:10px;position:absolute;'>
    </div>

    <div style='top:80px;left:90px;width:20px;height:40px;background:#780e20;-webkit-transform:rotate(240deg)
    translate(0,-80px);transform:rotate(240deg) translate(0,-80px);border-radius:10px;position:absolute;'>
    </div>

    <div style='top:80px;left:90px;width:20px;height:40px;background:#780e20;-webkit-transform:rotate(270deg)
    translate(0,-80px);transform:rotate(270deg) translate(0,-80px);border-radius:10px;position:absolute;'>
    </div>

    <div style='top:80px;left:90px;width:20px;height:40px;background:#780e20;-webkit-transform:rotate(300deg)
    translate(0,-80px);transform:rotate(300deg) translate(0,-80px);border-radius:10px;position:absolute;'>
    </div>

    <div style='top:80px;left:90px;width:20px;height:40px;background:#780e20;-webkit-transform:rotate(330deg)
    translate(0,-80px);transform:rotate(330deg) translate(0,-80px);border-radius:10px;position:absolute;'>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/shared/loading/loading.component.html